import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _ProductLot } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { InputDate } from "../../../../../../theme/Input/InputDate";
import { ProductionOrderEditor } from "../../../../../../Factoty&Production/ProductionOrder/ProductionOrderEditor";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_LG } from "../../../../../../theme/Component/hooks/useModal";
import { QualityInspectionLote } from "../../../../../../Factoty&Production/Quality/QualityInspectionLot/QualityInspectionLote";


interface componentProps {
    Inspection?: boolean;
}


export const ProductLotCatalogByProductionOrde = ({ Inspection }: componentProps) => {

    const { instance, setBean, bean, lista, setLista, update, deleteItemVoid, handleChange } = useDataBean(_ProductLot);
    const [order, setOrder] = useState<any>(null)

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalInspection = useModal("", MODAL_LG);

    // useEffect(() => {
    //     getLista()

    // }, [order])


    const getLista = () => {

        instance.getProductLotCatalogByProductionOrder(order.IDProductionOrder, order.ProductionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        setBean({
            // Year: year,
            // IDProduct: product
            IDProductionOrder: bean.IDProductionOrder
        });

        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        update().then(
            (resp: any) => {
                // getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }





    const head = [
        { title: 'ID', property: 'IDLot', visible: true },
        { title: 'Orden de Producción', property: 'ProductionOrderName', visible: true },
        { title: 'Código de Referencia de Lote', property: 'LotNumber', visible: true },
        { title: 'Producto', property: 'ProductName', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Fecha de Empaque', property: 'ProductionDate', visible: true },
        { title: 'Vecha de Vencimiento', property: 'DueDate', visible: true },
        { title: 'Número de Cajas', property: 'BoxNumber', visible: true },
        { title: 'Items por Caja', property: 'ItemsPerBox', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate() && !Inspection, icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit() && !Inspection, evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Inspecciones de Calidad', icono: 'ri-list-check', visible: _single.canEdit() && Inspection, evento: () => { modalInspection.open("Inspecciones de Calidad") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete() && !Inspection, evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const deleteItem = () => {
        deleteItemVoid(bean.IDLot).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }

    return (
        <BasicPage titulo="Lotes de Producción / Orden de Producción">
            <div className="row">
                <div className="col-md-6">

                    <ProductionOrderEditor IDOrderProduction={order} returnData={(e) => { setOrder({ ...order, "IDProductionOrder": e.IDProductionOrder, "ProductionOrderDate": e.ProductionOrderDate }); console.log(e) }} />

                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton icon="ri-send-plane-fill" eventClick={getLista}>Buscar por Orden*</BasicButton>
                </div>

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <ProductionOrderEditor IDOrderProduction={bean.IDProductionOrder} returnData={(e) => { setBean({ ...bean, "IDProductionOrder": e.IDProductionOrder, "ProductionOrderDate": e.ProductionOrderDate }); console.log(e) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Código de Referencia de Lote</label>
                                    <input name="LotNumber" className="form-control" value={bean.LotNumber} onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label>Fecha Empaque</label>
                                    <InputDate name="desde" label="Hasta" value={bean.ProductionDate} setDate={(e: any) => { setBean({ ...bean, "ProductionDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Fecha Vencimiento</label>
                                    <InputDate name="desde" label="Hasta" value={bean.DueDate} setDate={(e: any) => { setBean({ ...bean, "DueDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Número de Cajas</label>
                                    <input name="BoxNumber" className="form-control" value={bean.BoxNumber} onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label>Items por Caja</label>
                                    <input name="ItemsPerBox" className="form-control" value={bean.ItemsPerBox} onChange={handleChange} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                                </div>
                            </div>
                        </>
                    </Modal>

                    <Modal modal={modalInspection.modal} updateModal={modalInspection.setModal}>
                        <QualityInspectionLote _Lot={bean} isModal />
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}